module.exports = __webpack_public_path__ + "img/oc_jump.f19c3f97.png";